import type {
  BasicMod,
  ComponentMod,
  EmbeddedMod,
} from "@src/store/slices/experienceBuilder/types";
import { createAsyncThunk } from "@src/store";
import { basicModSlice } from "@src/store/slices/experienceBuilder/basicMod/slice";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const initDraft = createAsyncThunk<void, EmbeddedMod>(
  "experienceBuilder/common/initDraft",
  (mod, { dispatch }) => {
    if (mod.category === "component") {
      dispatch(componentSlice.actions._initDraft(mod));
    } else {
      dispatch(basicModSlice.actions._initDraft(mod));
    }
    dispatch(experienceBuilderSlice.actions.blurMod());
  }
);
